export default __webpack_public_path__ + "static/media/025-boarding-pass.2fe16b63.svg";